// extracted by mini-css-extract-plugin
export default {"page":"MainPage_page__gsbyf"};